export default "__VITE_ASSET__CQyZIbt___"